import DialogComponent from "@/app/components/dialog/form-dialog-component.vue";
import { RenderItem, RenderType } from "@/app/Types";
import { ExternalContext } from "@/app/contexts/externalContext";
import { DynamicForm } from "@/app/dynamic-components/forms/dynamic-form.model";

export interface FormDialogModel {
  title: string;
  form: RenderItem;
  externalContext: ExternalContext;

  referenceId: string;
  referenceType: string;

  destroyLabel: string | null;
  submitLabel: string | null;

  multiplicityReference?: string | null; //key to loop over multiple instance while creating/destroying form

  canSubmitRule?: string;
  canDeleteRule?: string;
}

export class FormDialogControl {
  private view: DialogComponent;

  submitChanges: (form: DynamicForm, formData: any, referenceId?: string) => Promise<boolean> = (form, formData, referenceId) => {
    return Promise.resolve(true);
  };
  afterSubmitChanges: (form: DynamicForm, formData: any, referenceId?: string) => Promise<any> = (form, formData, referenceId) => {
    return Promise.resolve(true);
  };

  destroyItem: (form: DynamicForm, formData: any, referenceId: string) => Promise<boolean> = (f, fd, iteù) => {
    return Promise.resolve(true);
  };
  afterDestroyItem: (form: DynamicForm, formData: any, referenceId: string) => Promise<any> = (f, fd, iteù) => {
    return Promise.resolve(true);
  };
  constructor(view: DialogComponent) {
    this.view = view;
  }

  transformBeforeSave: (form: DynamicForm, formData: any, formReferenceId: string | undefined, multiplicityReferenceId: string | undefined) => Promise<boolean> = (form, formData, referenceId, multiplicityReferenceId) => {
    return Promise.resolve(true);
  };

  destroyDone: () => Promise<void> = () => {
    return Promise.resolve();
  };

  submitDone: () => Promise<void> = () => {
    return Promise.resolve();
  };

  show(referenceId?: string, initFormData?: any) {
    if (this.view) this.view.showDialog(referenceId, initFormData);
  }

  close() {
    if (this.view) this.view.closeDialog();
  }



  setReferenceId(referenceId: string){
    if (this.view?.formDialogModel) this.view.formDialogModel.referenceId = referenceId;
  }

  getReferenceId(): string | undefined{
    return this.view?.formDialogModel?.referenceId
  }

  setReferenceType(referenceType: string){
    if (this.view?.formDialogModel) this.view.formDialogModel.referenceType = referenceType;
  }

  getReferencereferenceType(): string | undefined{
    return this.view?.formDialogModel?.referenceType
  }
}
